module.exports = __webpack_public_path__ + "static/media/logo_unescofe1.58155805.webp";